const TEST_EPCIS_OPTIONS = [
  {
    epci: '200041762',
    name: 'Rochefort Océan',
    count: 2826,
    isGroup: false
  },
  {
    epci: '241700434',
    name: 'La Rochelle',
    count: 1526,
    isGroup: false
  },
  {
    epci: '200036473',
    name: 'Saintes',
    count: 954,
    isGroup: false
  },
  {
    epci: '200041523',
    name: 'Haute-Saintonge',
    count: 2509,
    isGroup: false
  },
  {
    epci: '241700640',
    name: 'Royan Atlantique',
    count: 3538,
    isGroup: false
  },
  {
    epci: '241700459',
    name: 'Destination Ile de Ré',
    count: 3333,
    isGroup: false
  },
  {
    epci: '241700624',
    name: 'Ile d\'Oléron',
    count: 1541,
    isGroup: false
  },
  {
    epci: '200041689',
    name: 'Vals de Saintonge',
    count: 1734,
    isGroup: false
  },
  {
    epci: '241700699',
    name: 'Bassin de Marennes',
    count: 294,
    isGroup: false
  },
  {
    epci: '241700517',
    name: 'Charente-Arnoult-Coeur de Saintonge',
    count: 237,
    isGroup: false
  },
  {
    epci: '200041614',
    name: 'Aunis Sud',
    count: 198,
    isGroup: false
  },
  {
    epci: '200041499',
    name: 'Aunis Atlantique',
    count: 172,
    isGroup: false
  },
  {
    epci: '241700632',
    name: 'Gémozac et de la Saintonge Viticole',
    count: 112,
    isGroup: false
  }
];

const TEST_CITIES = [
  {
    insee: '17323',
    name: 'Saint-Denis-d\'Oléron',
    count: 248,
    isGroup: false
  },
  {
    insee: '17461',
    name: 'Vaux-sur-Mer',
    count: 238,
    isGroup: false
  },
  {
    insee: '17286',
    name: 'Les Portes-en-Ré',
    count: 228,
    isGroup: false
  },
  {
    insee: '17207',
    name: 'Loix',
    count: 226,
    isGroup: false
  },
  {
    insee: '17140',
    name: 'Dolus-d\'Oléron',
    count: 200,
    isGroup: false
  },
  {
    insee: '17337',
    name: 'Saint-Georges-d\'Oléron',
    count: 200,
    isGroup: false
  },
  {
    insee: '17230',
    name: 'Meschers-sur-Gironde',
    count: 182,
    isGroup: false
  },
];

const TEST_THESAURUS = [
  {
    code: '02.01.03.01.12',
    count: 232,
    isGroup: false
  },
  {
    code: '02.01.03.03.38',
    count: 340,
    isGroup: false
  },
  {
    code: '02.01.03.04.02',
    count: 317,
    isGroup: false
  },
  {
    code: '02.01.03.01.10',
    count: 259,
    isGroup: false
  },
];

const TEST_METRICS = {
  total: 18974,
  epcis: TEST_EPCIS_OPTIONS,
  cities: TEST_CITIES,
  testThesaurus: TEST_THESAURUS,
};

const TEST_SELECTIONS = [
  {
    filter: {
      id: 'epcis',
      type: 'epcis',
    },
    selection: [
      {
        epci: '241700434',
      },
      {
        epci: '200041762',
      },
    ],
  },
];

export { TEST_METRICS, TEST_EPCIS_OPTIONS, TEST_SELECTIONS, TEST_CITIES, TEST_THESAURUS };